import { gql } from '@apollo/client';


// Define the fragment for cache operations
export const CATALOG_FIELDS = gql`
  fragment CatalogFields on Catalog {
    id
    name
    description
    logo
    phone
    socialMedia {
      facebook
      instagram
    }
    theme
    viewMode
    allowCheckout
    businessType
    businessCategory
    location
    setupCompleted
    festiveMode
  }
`;

// ...existing code...

export const CREATE_ITEM = gql`
  mutation CreateItem(
    $name: String!
    $description: String
    $priceVariants: [PriceVariantInput]
    $catalog: ID!
    $category: ID
    $image: String
    $scheduledStart: String
    $scheduledEnd: String
    $repeatAvailability: [RepeatAvailabilityInput]
    $isVisible: Boolean
    $manageInventory: Boolean
    $stockTotal: Int
    $hasVariants: Boolean
    $productType: ProductType
    $requiresShipping: Boolean
    $pendingDigitalAssets: [PendingDigitalAssetInput]
    $digitalSettings: DigitalSettingsInput
    $digitalLinks: [DigitalLinkInput]
  ) {
    createItem(
      name: $name
      description: $description
      priceVariants: $priceVariants
      catalog: $catalog
      category: $category
      image: $image
      scheduledStart: $scheduledStart
      scheduledEnd: $scheduledEnd
      repeatAvailability: $repeatAvailability
      isVisible: $isVisible
      manageInventory: $manageInventory
      stockTotal: $stockTotal
      hasVariants: $hasVariants
      productType: $productType
      requiresShipping: $requiresShipping
      pendingDigitalAssets: $pendingDigitalAssets
      digitalSettings: $digitalSettings
      digitalLinks: $digitalLinks
    ) {
      id
      name
      description
      priceVariants {
        variant
        price
        stock
        sku
        lowStockThreshold
      }
      image
      isVisible
      productType
      digitalAssets {
        id
        filename
        originalName
        fileSize
        fileType
        assetType
        linkUrl
        linkDescription
        linkType
      }
      digitalSettings {
        downloadLimit
        linkExpiryHours
        allowPreview
        previewDuration
      }
    }
  }
`;

export const UPDATE_ITEM = gql`
  mutation UpdateItem(
    $id: ID!
    $name: String
    $description: String
    $priceVariants: [PriceVariantInput]
    $category: ID
    $image: String
    $isVisible: Boolean
    $productType: ProductType
    $digitalSettings: DigitalSettingsInput
    $requiresShipping: Boolean
    $digitalLinks: [DigitalLinkInput]
    $pendingDigitalAssets: [PendingDigitalAssetInput]
  ) {
    updateItem(
      id: $id
      name: $name
      description: $description
      priceVariants: $priceVariants
      category: $category
      image: $image
      isVisible: $isVisible
      productType: $productType
      digitalSettings: $digitalSettings
      requiresShipping: $requiresShipping
      digitalLinks: $digitalLinks
      pendingDigitalAssets: $pendingDigitalAssets
    ) {
      id
      name
      description
      priceVariants {
        variant
        price
        stock
        sku
        lowStockThreshold
      }
      image
      isVisible
      productType
      digitalAssets {
        id
        filename
        originalName
        fileSize
        fileType
        assetType
        linkUrl
        linkDescription
        linkType
      }
      digitalSettings {
        downloadLimit
        linkExpiryHours
        allowPreview
        previewDuration
      }
    }
  }
`;



export const UPLOAD_DIGITAL_ASSET = gql`
  mutation UploadDigitalAsset($itemId: ID!, $file: Upload!) {
    uploadDigitalAsset(itemId: $itemId, file: $file) {
      id
      filename
      originalName
      fileSize
      fileType
      storageUrl
      storageProvider
      uploadedAt
      isActive
    }
  }
`;

export const REMOVE_DIGITAL_ASSET = gql`
  mutation RemoveDigitalAsset($itemId: ID!, $assetId: ID!) {
    removeDigitalAsset(itemId: $itemId, assetId: $assetId)
  }
`;

export const UPDATE_DIGITAL_SETTINGS = gql`
  mutation UpdateDigitalSettings($itemId: ID!, $settings: DigitalSettingsInput!) {
    updateDigitalSettings(itemId: $itemId, settings: $settings) {
      id
      digitalSettings {
        downloadLimit
        linkExpiryHours
        allowPreview
        previewDuration
      }
    }
  }
`;

// Add these new queries for digital links

export const ADD_DIGITAL_LINK = gql`
  mutation AddDigitalLink($itemId: ID!, $linkInput: DigitalLinkInput!) {
    addDigitalLink(itemId: $itemId, linkInput: $linkInput) {
      id
      filename
      originalName
      fileSize
      fileType
      storageUrl
      storageProvider
      uploadedAt
      isActive
      assetType
      linkUrl
      linkDescription
      linkType
    }
  }
`;

export const GENERATE_DOWNLOAD_LINK = gql`
  mutation GenerateDownloadLink($transactionRef: String!, $itemId: ID!) {
    generateDownloadLink(transactionRef: $transactionRef, itemId: $itemId)
  }
`;


export const UPDATE_PAYMENT_SETTINGS = gql`
  mutation UpdatePaymentSettings($catalogId: ID!, $settings: PaymentSettingsInput!) {
    updatePaymentSettings(catalogId: $catalogId, settings: $settings) {
      success
      message
      catalog {
        id
        allowOnlinePayment
        paymentSettings {
          bankAccount {
            bankName
            accountNumber
            accountName
            bankCode
            verificationStatus
            dateVerified
          }
          splitPercentage
          settlementSchedule
        }
      }
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      accessToken
      refreshToken
      user {
        id
        name
        email
      }
    }
  }
  `;

export const REGISTER_USER = gql`
  mutation RegisterUser(
    $name: String!, 
    $email: String!, 
    $password: String!, 
    $businessName: String!,
    $catalogName: String!,
    $isSubscribed: Boolean!
  ) {
    register(
      name: $name, 
      email: $email, 
      password: $password, 
      businessName: $businessName, 
      catalogName: $catalogName,
      isSubscribed: $isSubscribed
    ) {
      accessToken
      refreshToken
      user {
        id
        name
        email
        isSubscribedToNewsletter
      }
      catalog {
        id
        name
        catalogName
      }
    }
  }
`;

export const GOOGLE_SIGN_IN = gql`
    mutation GoogleSignIn($token: String!, $email: String!, $name: String!) {
        googleSignIn(token: $token, email: $email, name: $name) {
        token
        user {
            id
            name
            email
        }
        }
    }
`;

export const UPDATE_TOUR_STATUS = gql`
  mutation UpdateTourStatus($input: UpdateTourStatusInput!) {
    updateTourStatus(input: $input) {
      overview
      catalog
      personalization
      statistics
      lastCompletedAt
    }
  }
`;

export const RESET_TOUR_STATUS = gql`
  mutation ResetTourStatus {
    resetTourStatus {
      overview
      catalog
      personalization
      statistics
      lastCompletedAt
    }
  }
`;


export const CREATE_CATALOG = gql`
    mutation CreateCatalog($name: String!, $catalogName: String!) {
        createCatalog(name: $name, catalogName: $catalogName) {
        id
        name
        catalogName
        user
        }
    }
`;


export const UPDATE_SELECTED_CATALOG = gql`
  mutation UpdateSelectedCatalog($userId: ID!, $catalogId: ID!) {
    updateSelectedCatalog(userId: $userId, catalogId: $catalogId)
  }
`;

export const CATALOG_PERFORMANCE = gql`
  query CatalogPerformance($catalogId: ID!, $days: Int!) {
    catalogPerformance(catalogId: $catalogId, days: $days) {
      totalCategories
      totalItems
      totalItemClicks
      performancePercentageChange
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      user {
        id
        name
        email
      }
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($id: ID!, $name: String, $email: String) {
    updateUser(id: $id, name: $name, email: $email) {
      id
      name
      email
    }
  }
`;


export const DELETE_CATALOG_MUTATION = gql`
  mutation DeleteCatalog($id: ID!) {
    deleteCatalog(id: $id) {
      success
      message
      deletedCategories
      deletedItems
      deletedImages
    }
  }
`;

export const DELETE_ACCOUNT_MUTATION = gql`
  mutation DeleteAccount {
    deleteAccount {
      success
      message
      deletedCatalogs
      deletedCategories
      deletedItems
      deletedImages
    }
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($currentPassword: String!, $newPassword: String!) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
      success
      message
    }
  }
`;



export const CREATE_CATEGORY = gql`
  mutation CreateCategory($name: String!, $catalog: ID!, $isVisible: Boolean) {
    createCategory(name: $name, catalog: $catalog, isVisible: $isVisible) {
      id
      name
      isVisible
    }
  }
`;



export const DELETE_ITEM = gql`
  mutation DeleteItem($id: ID!) {
    deleteItem(id: $id)
  }
`;

export const UPDATE_CATEGORY = gql`
mutation UpdateCategory($id: ID!, $name: String, $isVisible: Boolean) {
  updateCategory(id: $id, name: $name, isVisible: $isVisible) {
    id
    name
    isVisible
  }
}
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($id: ID!) {
    deleteCategory(id: $id)
  }
`;


export const UPDATE_CATALOG = gql`
  mutation UpdateCatalog(
    $id: ID!
    $name: String
    $description: String
    $logo: String
    $phone: String
    $socialMedia: SocialMediaInput
    $theme: String
    $viewMode: String
    $allowCheckout: Boolean
    $businessType: BusinessType
    $businessCategory: String
    $location: String
    $festiveMode: Boolean
  ) {
    updateCatalog(
      id: $id
      name: $name
      description: $description
      logo: $logo
      phone: $phone
      socialMedia: $socialMedia
      theme: $theme
      viewMode: $viewMode
      allowCheckout: $allowCheckout
      businessType: $businessType
      businessCategory: $businessCategory
      location: $location
      festiveMode: $festiveMode
    ) {
      id
      name
      description
      logo
      phone
      socialMedia {
        facebook
        instagram
      }
      theme
      viewMode
      allowCheckout
      businessType
      businessCategory
      location
      setupCompleted
      festiveMode
      
    }
  }
`;


export const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      success
      message
      # token  # Remove this in production
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($token: String!, $newPassword: String!) {
    resetPassword(token: $token, newPassword: $newPassword) {
      success
      message
    }
  }
`;

export const SET_NEW_PASSWORD = gql`
  mutation SetNewPassword($token: String!, $password: String!) {
    setNewPassword(token: $token, password: $password) {
      success
      message
    }
  }
`;

export const SEND_VERIFICATION_EMAIL = gql`
  mutation SendVerificationEmail($email: String!) {
    sendVerificationEmail(email: $email) {
      success
      message
    }
  }
`;

export const VERIFY_EMAIL = gql`
  mutation VerifyEmail($token: String!) {
    verifyEmail(token: $token) {
      success
      message
    }
  }
`;

export const UPDATE_ONBOARDING_STATUS = gql`
  mutation UpdateOnboardingStatus($input: UpdateOnboardingStatusInput!) {
    updateOnboardingStatus(input: $input) {
      id
      onboardingStatus
      onboardingStep
    }
  }
`;

export const REORDER_CATALOG = gql`
  mutation ReorderCatalog($catalogId: ID!, $newOrder: [ReorderInput!]!) {
  reorderCatalog(catalogId: $catalogId, newOrder: $newOrder) {
    success
    message
    updatedOrder {
      categoriesWithItems {
        id
        name
        order
        items {
          id
          name
          order
        }
      }
      itemsWithoutCategory {
        id
        name
        order
      }
    }
  }
}
`;

export const SUBMIT_CONTACT_FORM = gql`
  mutation SubmitContactForm($name: String!, $email: String!, $message: String!) {
    submitContactForm(name: $name, email: $email, message: $message) {
      success
      message
    }
  }
`;

export const SUBMIT_FEEDBACK = gql`
  mutation SubmitFeedback($input: FeedbackInput!) {
    submitFeedback(input: $input) {
      id
      rating
      comment
      createdAt
      user {
        id
        name
      }
    }
  }
`;

export const SUBSCRIBE_TO_NEWSLETTER = gql`
    mutation SubscribeToNewsletter($email: String!) {
        subscribeToNewsletter(email: $email)
    }
`;

export const UNSUBSCRIBE_FROM_NEWSLETTER = gql`
  mutation UnsubscribeFromNewsletter($email: String!) {
    unsubscribeFromNewsletter(email: $email)
  }
`;

export const VERIFY_BANK_ACCOUNT = gql`
  mutation VerifyBankAccount($catalogId: ID!, $accountDetails: BankAccountInput!) {
    verifyBankAccount(catalogId: $catalogId, accountDetails: $accountDetails) {
      success
      message
      verificationStatus
      accountDetails {
        bankName
        accountNumber
        accountName
        bankCode
      }
    }
  }
`;

export const UPDATE_BANK_DETAILS = gql`
  mutation UpdateBankDetails($catalogId: ID!, $bankDetails: BankAccountInput!) {
    updateBankDetails(catalogId: $catalogId, bankDetails: $bankDetails) {
      success
      message
      paymentSettings {
        bankAccount {
          bankName
          accountNumber
          accountName
          bankCode
          verificationType
          verificationStatus
          dateVerified
        }
      }
    }
  }
`;

export const CREATE_WHATSAPP_ORDER = gql`
  mutation CreateWhatsAppOrder($input: WhatsAppOrderInput!) {
    createWhatsAppOrder(input: $input) {
      id
      reference
      amount
      status
      paymentMethod
      gateway
      items {
        itemId
        name
        quantity
        price
      }
    }
  }
`;

export const SETTLE_NOW = gql`
    mutation SettleNow($catalogId: ID!) {
        settleNow(catalogId: $catalogId) {
            success
            message
            settlementsInitiated
            totalAmount
        }
    }
`;

export const VERIFY_SETTLEMENT = gql`
  mutation VerifySettlement($reference: String!) {
    verifySettlement(reference: $reference) {
      success
      status
      message
      transaction {
        id
        reference
        settlementStatus
      }
    }
  }
`;



export const UPDATE_INVENTORY = gql`
  mutation UpdateInventory($itemId: ID!, $variants: [PriceVariantInput]) {
    updateInventory(itemId: $itemId, variants: $variants) {
      success
      message
      item {
        id
        name
        manageInventory
        stockTotal
        hasVariants
        priceVariants {
          variant
          price
          stock
          sku
          lowStockThreshold
        }
      }
    }
  }
`;

export const ADJUST_STOCK = gql`
  mutation AdjustStock($itemId: ID!, $variantIndex: Int, $adjustment: Int!) {
    adjustStock(itemId: $itemId, variantIndex: $variantIndex, adjustment: $adjustment) {
      success
      message
      item {
        id
        stockTotal
        priceVariants {
          variant
          price
          stock
        }
      }
    }
  }
`;

export const TOGGLE_INVENTORY_MANAGEMENT = gql`
  mutation ToggleInventoryManagement($itemId: ID!, $manageInventory: Boolean!) {
    toggleInventoryManagement(itemId: $itemId, manageInventory: $manageInventory) {
      success
      message
      item {
        id
        manageInventory
      }
    }
  }
`;